import { render, staticRenderFns } from "../template/reg_3.html?vue&type=template&id=7dea2f49&external"
import script from "./Reg-3.vue?vue&type=script&lang=js"
export * from "./Reg-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports